import Vue from 'vue'

import VueSilentbox from 'vue-silentbox'

Vue.use(VueSilentbox)
